import { kea } from "kea";
import api from '../utils/api';

import { maplogic, infowindowlogic } from './global';
import grouplogic from "./group";
import profilelogic from "./profile";
import checkRole from "src/utils/checkRole";

export const vehiclelogic = kea({
	actions: {
		create: (body) => ({ body }),
		fetchAll: true,
		update: (vehicle) => ({ vehicle }),
		remove: (vehicle) => ({ vehicle }),
		updateGroup: (vehicle) => ({ vehicle }),
		updateKey: (vehicle) => ({ vehicle }),
		fetchUpdatedPosition: (vehicles, timestamp) => ({ vehicles, timestamp }),
		fetchHistory: (vehicle) => ({ vehicle }),
		fetchReplay: (vehicle) => ({ vehicle }),
		fetchNearbyAssets: (vehicle) => ({ vehicle }),
		updateImage: (vehicle) => ({ vehicle }),
		immobilise: (state) => ({ state }),
		doorlock: (state) => ({ state }),
		requestTripCounter: (state) => ({ state }),
		resetTripCounter: (state) => ({ state }),
		simStatus: (state) => ({ state }),
		getRecord: (state) => ({ state }),

		setAll: (vehicles) => ({ vehicles }),
		setOne: (vehicle) => ({ vehicle }),
		removeOne: (vehicle) => ({ vehicle }),
		setPosition: (vehicles) => ({ vehicles }),
		setHistory: (history) => ({ history }),
		setReplay: (replay) => ({ replay }),
		setNearbyAssets: (nearbyAssets) => ({ nearbyAssets }),
		setTripCounter: (counter) => ({ counter }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),

		onMapAdd: (vehicle) => ({ vehicle }),
		onMapRemove: (vehicle) => ({ vehicle }),
		setSelected: (vehicle) => ({ vehicle }),
	},
	selectors: {
		vehiclesOnMap: [
			(selectors) => [selectors.vehicles, selectors.onMap],
			(vehicles, onMap) => vehicles.filter(vehicle => onMap.includes(vehicle._id))
		],
		//TODO get selected
		selected: [
			(selectors) => [selectors.vehicles, selectors.selected],
			(vehicles, selected) => vehicles.find(vehicle => vehicle._id === selected)
		]
	},
	reducers: {
		vehicles: [null, {
			setAll: (_, { vehicles }) => vehicles,
			setOne: (state, { vehicle }) => state.map((s) => s._id === vehicle._id ? vehicle : s),
			removeOne: (state, { vehicle }) => state.filter((s) => vehicle._id !== s._id),
			setPosition: (state, { vehicles }) => state.map((outdated) => {
				for (const updated of vehicles) {
					if (updated._id === outdated._id) {
						outdated.tracker.status = updated.tracker.status;
						break;
					}
				}
				return outdated;
			})
		}],
		onMap: [[], {
			onMapAdd: (state, { vehicle }) => [...state, vehicle],
			onMapRemove: (state, { vehicle }) => state.filter((_id) => vehicle !== _id),
		}],
		selected: [null, {
			setSelected: (_, { vehicle }) => vehicle,
		}],
		history: [[], {
			setHistory: (_, { history }) => history,
		}],
		nearbyAssets: [[], {
			setNearbyAssets: (_, { nearbyAssets }) => nearbyAssets,
		}],
		replay: [[], {
			setReplay: (_, { replay }) => replay,
		}],
		tripCounter: [null, {
			setTripCounter: (_, { counter }) => counter
		}],
		loading: [false, {
			create: () => true,
			fetchAll: () => true,
			update: () => true,
			remove: () => true,
			updateGroup: () => true,
			fetchUpdatedPosition: () => true,
			fetchHistory: () => true,
			fetchReplay: () => true,
			fetchNearbyAssets: () => true,
			immobilise: () => true,
			doorlock: () => true,
			requestTripCounter: () => true,
			resetTripCounter: () => true,
			getRecord: () => true,
			simStatus: () => true,
			updateImage: () => true,

			setAll: () => false,
			setOne: () => false,
			removeOne: () => false,
			setPosition: () => false,
			setHistory: () => false,
			setReplay: () => false,
			setNearbyAssets: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		historyloading: [false, {
			fetchHistory: () => true,

			setHistory: () => false,
			setError: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			removeOne: () => null,
			setPosition: () => null,
			setHistory: () => null,
			setReplay: () => null,
			setNearbyAssets: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/vehicle';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		simStatus: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/simstatus`;
			let res;
			try {
				res = await api({ url, method: 'put', body: state });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Vehicle Updated.');
			} else actions.setError(json.error);
		},
		doorlock: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/doorlock`;
			let res;
			try {
				res = await api({ url, method: 'put', body: state });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setSuccess('Door Lock/Unlock Command Sent.');
			} else actions.setError(json.error);
		},
		requestTripCounter: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/trip_counter`;
			let res;
			try {
				res = await api({ url, method: 'get' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setTripCounter(json.payload);
				actions.setSuccess('Trip Counter Fetched.');
			} else actions.setError(json.error);
		},
		resetTripCounter: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/trip_counter`;
			let res;
			try {
				res = await api({ url, method: 'put' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setSuccess('Trip Counter Reset.');
			} else actions.setError(json.error);
		},
		getRecord: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/command/get_record`;
			let res;
			try {
				res = await api({ url, method: 'post' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setSuccess('Command Sent.');
			} else actions.setError(json.error);
		},
		immobilise: async ({ state }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${state._id}/immobilise`;
			let res;
			try {
				res = await api({ url, method: 'put', body: state });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setSuccess('(Im)mobliser Command Sent.');
			} else actions.setError(json.error);
		},
		update: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}`;
			let res;
			try {
				res = await api({ url, method: 'put', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Vehicle Updated.');
			} else actions.setError(json.error);
		},
		updateKey: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/key`;
			let res;
			try {
				res = await api({ url, method: 'put', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Vehicle Updated.');
			} else actions.setError(json.error);
		},
		updateGroup: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/group`;
			let res;
			try {
				res = await api({ url, method: 'put', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Vehicle Updated.');
			} else actions.setError(json.error);
		},
		fetchUpdatedPosition: async ({ vehicles, timestamp }, breakpoint) => {
			// await breakpoint(300);
			let url = `/vehicle/update_location`;
			let res;
			try {
				res = await api({
					url, method: 'post', body: {
						vehicles: vehicles.map(v => {
							return {
								_id: v._id
							}
						}), timestamp
					}
				});
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				// return json.payload;
				actions.setPosition(json.payload);
				infowindowlogic.actions.setPosition(json.payload);
				maplogic.actions.setPosition(json.payload);
			} else actions.setError(json.error);
		},
		fetchNearbyAssets: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/nearbyassets`;
			let res;
			try {
				res = await api({ url, method: 'post', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setNearbyAssets(json.payload);
				actions.setSuccess('Nearby Assets Fetched.');
			} else actions.setError(json.error);
		},
		fetchHistory: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/history`;
			let res;
			try {
				res = await api({ url, method: 'post', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setHistory(json.payload);
				if (!json.payload.status.length) actions.setSuccess('History fetched but is empty');
				else actions.setSuccess('History Fetched.');
			} else actions.setError(json.error);
		},
		fetchReplay: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/replay`;
			let res;
			try {
				res = await api({ url, method: 'post', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setReplay(json.payload);
				if (!json.payload.status.length) actions.setSuccess('Replay fetched but is empty');
				else actions.setSuccess('Replay Fetched.');
			} else actions.setError(json.error);
		},
		updateImage: async ({ vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/vehicle/${vehicle._id}/update_image`;
			let res;
			try {
				res = await api({ url, method: 'put', body: vehicle });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload);
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Vehicle Updated.');
			} else actions.setError(json.error);
		},
	})
});

export default vehiclelogic;
